const text = (maxLength) => ({ type: "string", maxLength });

const properties = {
  message: text(500),
  name: text(100),
  stack: text(8000),
  componentStack: text(8000),
  section: text(50),
  path: text(2048),
  browserLanguage: text(35),
  userAgent: text(1000),
  release: text(100),
  occurredAt: {
    type: "string",
    pattern: "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{3}Z$",
  },
};

export const CRASH_REPORT_SCHEMA = Object.freeze({
  type: "object",
  properties,
  required: Object.keys(properties),
  additionalProperties: false,
});

export const CRASH_REPORT_LIMITS = Object.freeze(
  Object.fromEntries(
    Object.entries(CRASH_REPORT_SCHEMA.properties)
      .filter(([, property]) => property.maxLength !== undefined)
      .map(([field, { maxLength }]) => [field, maxLength]),
  ),
);
